<template>
  <div>
    <b-modal ref="game-result-details-modal"
       :title="$t('game_results_tournament.modal.title')"
       ok-only
       size="lg"
    >
      <div>
        <div v-if="isLoading" class="text-center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-table v-if="!isLoading" striped hover :items="playerCollection" :fields="fields">
          <template #cell(id)="data">
            {{ data.item.id.split('-')[0] }}
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import sortBy from 'lodash/sortBy';

export default {
  data() {
    return {
      sortBy: 'finalClassificationPlace',
      sortDesc: false,
      fields: [
        { key: 'id', label: this.$t('table.header.game_result_id'), sortable: false },
        { key: 'nickName', label: this.$t('table.header.game_result_nick_name'), sortable: false },
        { key: 'finalClassificationPlace', label: this.$t('table.header.final_place'), sortable: false }
      ],
      isLoading: true,
      playerCollection: null
    };
  },
  methods: {
    showDetails(data) {
      this.isLoading = true;
      this.getData(data.gameId);
      this.$refs['game-result-details-modal'].show();
    },
    getData(gameId) {
      return axios.get(`/api/game/${gameId}/game-history-item-details`).then(response => {
        this.playerCollection = sortBy(response.data.players, 'finalClassificationPlace');
        this.isLoading = false;
      });
    }
  }
}
</script>
